import React from 'react';
import { CountContainer, LabelCount } from '../searchDropdown/SearchDropdown.styled';

const CountBadge = ({
    id,
    count = 0,
    colorNote = false,
    backgroundColor = '#12C8F7',
    border = '1px solid #140F4B',
    ...props
}) => {
    if (count <= 0) {
        return null;
    }

    const badgeLabel = count > 99 ? '99+' : String(count);
    const isMultiDigit = badgeLabel.length > 1;

    return (
        <CountContainer
            id={id}
            colorNote={colorNote}
            backgroundColor={backgroundColor}
            border={border}
            isMultiDigit={isMultiDigit}
            {...props}
        >
            <LabelCount colorNote={colorNote} isMultiDigit={isMultiDigit}>
                {badgeLabel}
            </LabelCount>
        </CountContainer>
    );
};

export default CountBadge;
